import React, { useEffect, useRef } from "react";

function OpinionsBodasnet() {
    const widgetRef = useRef(null);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdn1.bodas.net/js/wp-widget.js?symfnw-ES171-1-20260923-006-0_www_m_";
        script.type = "application/javascript";
        script.async = true;
        script.dataset.mountIn = ".bodas-net";
        document.body.appendChild(script);
        script.onload = () => window.wpShowReviews(201360, 'red');
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <section className="container-fluid pb-5 mb-5 75vw bg-white pt-5 text-highlight">
            <div ref={widgetRef} className="" data-prop-name="cm-widget1" ></div>
            <div className="bodas-net" id="wp-widget-reviews">
                <div id="wp-widget-preview">
                    Lee <a href="https://www.bodas.net/belleza-novias/kriskisstyle--e201360/opiniones" rel="nofollow" rel="nofollow">nuestras opiniones</a> en &nbsp;
                    <a href='https://www.bodas.net' rel="nofollow">
                        <img src="https://cdn1.bodas.net/assets/img/logos/gen_logoHeader.svg" alt="logobodas" height="20"></img>
                    </a>
                </div>
            </div>

        </section>
    );
}

export default OpinionsBodasnet;
